module.exports = __webpack_public_path__ + "static/media/christian-villaran.cabab3e4.png";